import styled from 'styled-components'

export const Container = styled.div`
  @media only screen and (min-width: 1000px) {
    position: relative;
  }
`

export const Filler = styled.div`
  display: none;

  @media only screen and (min-width: 1000px) {
    display: block;
    position: relative;
    width: 346px;
    height: 100vh;

    z-index: 10;

    flex-shrink: 0;

    transition: width 0.3s ease;

    .line {
      position: absolute;
      left: 0px;
      height: 100%;

      width: 1px;
      background-color: ${({ theme }) => (theme.isDark ? '#C6C6C6' : '#d9d9d9')};
    }

    &[data-is-open='false'] {
      width: 0;

      .line {
        animation: animate-line 0.2s ease 0.3s forwards;
      }
    }
  }

  @keyframes animate-line {
    to {
      left: 29px;
    }
  }
`

export const Drawer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  width: min(346px, 94vw);

  z-index: 2000;

  background-color: ${({ theme }) => (theme.isDark ? '#0D0D0D' : '#fff')};
  border-right: 1px solid ${({ theme }) => (theme.isDark ? '#C6C6C6' : '#d9d9d9')};

  transition: all 0.3s ease;

  &[data-is-open='false'] {
    transform: translateX(-100%);

    .arrow-button {
      animation: animate-arrow-mobile 0.2s ease 0.3s forwards;
    }
  }

  .arrow-button {
    position: absolute;
    top: 85px;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    transform: translateX(calc(50% - 4px));

    padding: 12px;
    border-radius: 100%;

    background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};
    border: 1px ${({ theme }) => (theme.isDark ? '#BABABA' : '#808080')} solid;

    color: ${({ theme }) => (theme.isDark ? '#fff' : '#5e6871')};

    box-shadow: 0px 4px 4px 0px #00000040;

    .icon {
      width: 24px;
      height: 24px;
    }
  }

  @media only screen and (min-width: 1000px) {
    position: absolute;

    .arrow-button {
      top: 54px;

      padding: 6px;

      transform: translateX(50%);

      .icon {
        width: 18px;
        height: 18px;
      }
    }

    &[data-is-open='false'] {
      .arrow-button {
        animation: animate-arrow-desktop 0.3s ease 0.3s forwards;
      }
    }
  }

  @keyframes animate-arrow-mobile {
    to {
      transform: translateX(calc(100% - 12px));
      border-radius: 0px 100% 100% 0px;
    }
  }

  @keyframes animate-arrow-desktop {
    to {
      transform: translateX(calc(100% + 12px));
    }
  }
`

export const Overlay = styled.div`
  background-color: #222222cc;

  position: fixed;
  inset: 0;

  z-index: 10;

  transition: opacity 0.3s ease;

  &[data-is-visible='false'] {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  @media only screen and (min-width: 1000px) {
    display: none;
  }
`

export const Content = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  height: 100%;

  .lessons {
    flex: 1;

    display: flex;
    flex-direction: column;

    overflow: auto;
  }
`

export const Upper = styled.div`
  padding: 20px 16px;

  .group {
    display: flex;
    align-items: center;
    gap: 14px;

    margin-bottom: 18px;

    .circle {
      min-height: unset;
      min-width: unset;

      flex-shrink: 0;

      .circular-chart {
        margin: 0;

        max-width: unset;
        max-height: unset;

        .circle {
          stroke: ${({ theme }) => (theme.isDark ? '#08DD0E' : '#0BC196')};
        }
      }

      .circle-bg {
        stroke: #dee5ef;
      }
    }

    .texts {
      .link {
        display: block;

        color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#4b4b4b')};
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        text-decoration: underline;

        margin-bottom: 12px;
      }

      .course-name {
        color: ${({ theme }) => (theme.isDark ? '#fff' : '#112138')};
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;

        word-break: break-word;

        margin-bottom: 8px;

        max-width: 200px;
      }

      .total-lessons {
        color: ${({ theme }) => (theme.isDark ? '#C6C6C6' : '#868686')};
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    padding: 32px 20px 16px 32px;
  }
`

export const SearchBar = styled.label`
  border-radius: 4px;
  width: 100%;
  max-width: 287px;

  padding: 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  border: 1px solid ${({ theme }) => (theme.isDark ? '#bababa' : '#3939392B')};
  background-color: ${({ theme }) => (theme.isDark ? '#222' : '#F9F9F9')};

  svg {
    height: 20px;
    width: 20px;

    flex-shrink: 0;

    opacity: 0.7;
    color: ${({ theme }) => (theme.isDark ? '#fff' : '#4a4a4a')};
  }

  input {
    border: none;
    background: transparent;
    width: 100%;

    font-size: 12px;
    font-weight: 600;

    color: ${({ theme }) => (theme.isDark ? '#fff' : '#4a4a4a')};

    &::placeholder {
      opacity: 0.7;
      color: currentColor;
    }
  }
`
